import { DataFilterOperator } from '@core/datafilter/filter-operator';
import { BcmUserTableSettingKey } from '@shared/models/bcm-settings-user';

export function removeRedundantDefaultActiveEmployeeFilter(): void {
    const storageKey = `${BcmUserTableSettingKey.Employees}_filters`;
    const raw = sessionStorage.getItem(storageKey);

    if (!raw) {
        return;
    }

    let persisted: { isActive?: { operator?: string; value?: unknown }[] };

    try {
        persisted = JSON.parse(raw);
    } catch {
        sessionStorage.removeItem(storageKey);
        return;
    }

    const isActiveFilters = persisted?.isActive;

    if (!Array.isArray(isActiveFilters) || isActiveFilters.length !== 1) {
        return;
    }

    const [filter] = isActiveFilters;

    if (filter?.operator !== DataFilterOperator.Equal || filter?.value !== true) {
        return;
    }

    delete persisted.isActive;

    if (Object.keys(persisted).length === 0) {
        sessionStorage.removeItem(storageKey);
    } else {
        sessionStorage.setItem(storageKey, JSON.stringify(persisted));
    }
}
